import { useEffect, useState } from 'react';

const CHIPS = [
  { months: 3, label: '3 个月', hint: '季度' },
  { months: 6, label: '6 个月', hint: '半年' },
  { months: 12, label: '12 个月', hint: '一年' },
  { months: 24, label: '24 个月', hint: '两年' },
  { months: 0, label: '自定义', hint: '' },
];

export interface TermChipsProps {
  startAt: string;
  endAt: string;
  onChange: (next: { startAt: string; endAt: string }) => void;
  defaultMonths?: number;
  /** 起始日只读（续签场景：起始日 = 当前合同到期 + 1 天，禁止改） */
  startDisabled?: boolean;
}

function pad(n: number) { return n < 10 ? '0' + n : '' + n; }
function fmt(d: Date) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }

export function addMonths(yyyymmdd: string, months: number): Date {
  const [y, m, d] = yyyymmdd.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const origDay = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() < origDay) date.setDate(0); // 月底回退
  return date;
}
export function diffMonths(start: string, end: string): number {
  const [sy, sm, sd] = start.split('-').map(Number);
  const [ey, em, ed] = end.split('-').map(Number);
  let m = (ey - sy) * 12 + (em - sm);
  if (ed < sd) m -= 0.5;
  return m;
}

export function TermChips({ startAt, endAt, onChange, defaultMonths = 12, startDisabled = false }: TermChipsProps) {
  const [active, setActive] = useState<number>(defaultMonths);

  useEffect(() => {
    if (active > 0 && startAt) {
      const e = fmt(addMonths(startAt, active));
      if (e !== endAt) onChange({ startAt, endAt: e });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startAt, active]);

  function onEndChange(v: string) {
    onChange({ startAt, endAt: v });
    setActive(0);
  }

  function pickChip(m: number) {
    if (m === 0) { setActive(0); return; }
    setActive(m);
  }

  const months = startAt && endAt ? diffMonths(startAt, endAt) : 0;

  return (
    <>
      <div className="field-row" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div className="field">
          <label className="field__label">合同起始<span className="req">*</span></label>
          <input
            className="input"
            type="date"
            value={startAt}
            disabled={startDisabled}
            onChange={(e) => onChange({ startAt: e.target.value, endAt })}
          />
          {startDisabled && (
            <div className="field__hint">续签场景：起始日 = 当前合同到期 + 1 天，不可修改</div>
          )}
        </div>
        <div className="field">
          <label className="field__label">合同到期<span className="req">*</span></label>
          <input className="input" type="date" value={endAt} onChange={(e) => onEndChange(e.target.value)} />
        </div>
      </div>
      <div className="field">
        <label className="field__label">租期快捷</label>
        <div className="term-chips">
          {CHIPS.map((c) => {
            const isActive = active === c.months;
            const customLabel = c.months === 0 && isActive && startAt && endAt
              ? `自定义 ≈ ${Number.isInteger(months) ? months : months.toFixed(1)} 个月`
              : c.label;
            return (
              <span
                key={c.months}
                role="button"
                aria-pressed={isActive}
                className={`term-chip${isActive ? ' is-active' : ''}`}
                onClick={() => pickChip(c.months)}
              >
                {customLabel}
                {c.hint && c.months !== 0 && <span className="term-chip__hint">{c.hint}</span>}
              </span>
            );
          })}
        </div>
        <div className="field__hint">点击快捷按起始日加 N 个月自动算到期；手动改到期日切到自定义。</div>
      </div>
    </>
  );
}
